import { useState } from "react"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import '../Forms.css'
import TextArea from '../FormComponents/TextArea/TextArea.js'
import SelectOptions from '../FormComponents/SelectOptions/SelectOptions.js'
import CheckBox from '../FormComponents/Checkbox/Checkbox.js'
import BookDate from "../FormComponents/Date/BookDate"
import SelectNumber from '../FormComponents/Number/SelectNumber.js'
import {API_ROOT} from '../../AppConfig/app-config.js'
import TextInput from "../FormComponents/TextInput/TextInput"
import { Alert } from 'react-bootstrap';
import Logout from '../Logout/Logout.js';
import LoginForm from "../Login/Login"

export default function BookingForm() {
    const [booking, setBooking] = useState(false);
    const [message, setMessage] = useState(null);

    if(booking === true){
        return(
            <div className="container formStyle" style={{"marginTop": "5rem"}}>
                <Alert variant="success">
                    <Alert.Heading>Your booking request has been submitted!</Alert.Heading>
                    <label>{message}</label>
                </Alert>
                <Logout/>
            </div>
        );
    } else if(message !== null && booking === false){
        return (
            <div className="container formStyle">
                <Alert variant="danger">
                    <Alert.Heading>Error</Alert.Heading>
                    <label>{message}</label>
                </Alert>
                <br/>
                <LoginForm/>
            </div>
        )
    }

    return(
        <div>
            <Formik
                initialValues={{
                    adults: "",
                    children: "",
                    date: "",
                    food: "",
                    request: "",
                    acceptedTerms: "",
                }}
                validationSchema={Yup.object({
                    adults: Yup.number()
                    .required("Required")
                    .positive(true)
                    .min(2,"Bookings are accepted for a minimum of 2 people")
                    .max(20, "Bookings are accepted for a maximum of 20 people")
                    .integer(),
                    children: Yup.number()
                    .required("Required"),
                    date: Yup.date()
                    .required("Required"),
                    vegfood: Yup.string()
                    .oneOf(
                    ["Select","0","1", "2", "3", "4", "5", "6","7", "8", "9", "10", "11", "12", "13", "14", "15"],
                    "Invalid Input"
                    )
                    .optional(),
                    nonvegfood: Yup.string()
                    .oneOf(
                    ["Select","0","1", "2", "3", "4", "5", "6","7", "8", "9", "10", "11", "12", "13", "14", "15"],
                    "Invalid Input"
                    )
                    .optional(),
                    request: Yup.string()
                    .required("Required"),
                    phoneNumber: Yup.string()
                    .required("Required"),
                    acceptedTerms: Yup.boolean()
                    .required("Required")
                    .oneOf([true], "You must accept the terms and conditions."),
                })}
                onSubmit={
                    async (values, { setSubmitting }) => {
                    await new Promise(r => setTimeout(r, 500));
                    setMessage(null);
                    fetch(`${API_ROOT}/booking`, {
                        credentials: 'include',
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(values)
                    })
                    .then(response => response.json()
                        .then(data => ({status:response.status, returnedBody: data})))
                    .then(returnedObj => {
                        const strMsg = returnedObj.returnedBody.msg;
                        if (returnedObj.status === 200){
                            setMessage(strMsg);
                            setBooking(true);
                        } else {
                            setMessage(strMsg);
                            setBooking(false);
                        }
                    })
                    .catch(error => {
                        console.error("Booking error:", error);
                        setMessage("Something went wrong. Please try again.");
                        setBooking(false);
                    })
                    .finally(() => {
                        setSubmitting(false);
                    });
                }}
            >

                <div className="formContainer">
                    <div className="formStyle" style={{"marginTop": "2rem"}}>
                    <Logout/>
                        <Form method="POST">
                            <SelectNumber
                                label="Adults:"
                                name="adults"
                            >
                            </SelectNumber>
                            <SelectNumber
                                label="Children:"
                                name="children"
                            >
                            </SelectNumber>
                            <BookDate
                                label="Choose a date:"
                                name="date"
                                placeholder='yyyy-mm-dd'
                                pattern ="\d{4}-\d{2}-\d{2}"
                            >
                            </BookDate>
                            <SelectOptions style={{"color":"black"}} label="Vegetarian Thali:" name="vegfood">
                                <option value="">Select</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                            </SelectOptions>
                            <br/>
                            <SelectOptions style={{"color":"black"}} label="Non-Vegetarian Thali:" name="nonvegfood">
                                <option value="">Select</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                            </SelectOptions>
                            <TextArea
                                label="Request:"
                                name="request"
                                type="text"
                            />
                            <TextInput
                                name="phoneNumber"
                                placeholder= "Phone Number"
                                pattern="[0-9]{10}"
                                type="tel"
                            />
                            <CheckBox name="acceptedTerms">
                                &nbsp; I have read all the <a href="/policies">terms and conditions</a>
                            </CheckBox>
                            <button
                                className="buttonStyle"
                                type="submit"
                            >
                                Submit
                            </button>
                        </Form>
                    </div>
                </div>
            </Formik>

        </div>
    );
}
